const PARTNERS = [
  { src: '/logos/partners/sap_logo_white.png', alt: 'SAP' },
  { src: '/logos/partners/dns_logo_white.png', alt: 'DNS' },
  { src: '/logos/partners/hitachi_logo_white.png', alt: 'Hitachi Vantara' },
  { src: '/logos/partners/cra_logo_white.png', alt: 'CRA' },
  { src: '/logos/partners/greenometer_logo_white.png', alt: 'Greenometer' },
  { src: '/logos/partners/isoma_logo_white.png', alt: 'ISOMA' },
  { src: '/logos/partners/natland_logo_white.png', alt: 'Natland' },
  { src: '/logos/partners/mizuno_logo_white.png', alt: 'Mizuno' },
  { src: '/logos/partners/cgf_logo_white.png', alt: 'Česká golfová federace' },
  { src: '/logos/partners/omnes_logo_white.png', alt: 'OMNES' },
  { src: '/logos/partners/msgplaut_logo_white.png', alt: 'msg Plaut' },
  { src: '/logos/partners/deloitte_logo_white.png', alt: 'Deloitte' },
];

export function PartnersCard() {
  return (
    <div className="partners-card">
      <h3 className="partners-title">Podporují</h3>
      <div className="partners-grid">
        {PARTNERS.map(p => (
          <div key={p.alt} className="partner-logo-wrapper">
            <img src={p.src} alt={p.alt} className="partner-logo" loading="lazy" />
          </div>
        ))}
      </div>
      <div className="partners-organizer">
        <img src="/logos/partners/cgp_logo_white.png" alt="Czech Golf Production" className="partner-logo-organizer" loading="lazy" />
      </div>
    </div>
  );
}
